import Axios from 'axios'
import Cookies from 'js-cookie'
import { TOKEN_KEY, localRead } from '@/libs/util'
import router from '@/router'
import config from '@/config/index'

const service = Axios.create({
  baseURL: config.Host
})

//请求拦截器
service.interceptors.request.use((config) => {
  // console.log(config)
  config.headers['lang'] = localRead('locale') || 'en'
  
  // 添加token到请求头
  const token = localStorage.getItem(TOKEN_KEY)
  if (token) {
    config.headers['Token'] = token
  }
  
  return config
})

// 添加响应拦截器
service.interceptors.response.use((response) => {
  // 对响应数据做点什么
  return response
}, (error) => {
  console.log(error)
  // 对响应错误做点什么
  if (error.response && error.response.status === 401) {
    localStorage.removeItem('token')
    router.push('/login')
  } else {
    return Promise.reject(error)
  }
})

// service.defaults.headers.common['Accept'] = '*/*'

export default service
